export default __webpack_public_path__ + "static/CircularXXWeb-Book-39e21067ffdf87ca6dfb7e79cbb81fea.woff2";